export const BROADCAST_EVENT_TYPE_LABELS: Record<string, string> = {
  // Canonical mappings from provided event_type list
  game_over: 'GAME OVER',
  game_over_home_team_wins: 'GAME OVER: HOME TEAM WINS',
  strikeout: 'STRIKEOUT',
  relief_pitcher: 'RELIEF PITCHER',
  fb: 'FLY BALL OUT',
  bb: 'WALK',
  defensive_switch: 'DEFENSIVE SWITCH',
  defensive_change: 'DEFENSIVE SWITCH',
  inning_start: 'INNING START',
  pinch_hitter: 'PINCH HITTER',
  gb: 'GROUND BALL OUT',
  gdp: 'GROUNDED INTO DOUBLE PLAY',
  '1b': 'SINGLE',
  '2b': 'DOUBLE',
  '3b': 'TRIPLE',
  fc: "FIELDER'S CHOICE",
  defensive_substitution: 'DEFENSIVE SUBSTITUTION',
  hr: 'HOME RUN',
  sb: 'STOLEN BASE',
  sf: 'SAC FLY',
  game_start: 'GAME START',
};

function normalizeEventTypeKey(eventType: string): string {
  return eventType.trim().toLowerCase().replace(/[\s-]+/g, '_');
}

function humanizeEventType(eventType: string): string {
  return eventType
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
}

export function getBroadcastEventTypeLabel(eventType?: string): string {
  const raw = String(eventType ?? '').trim();
  if (!raw) return '';
  const normalized = normalizeEventTypeKey(raw);
  return BROADCAST_EVENT_TYPE_LABELS[normalized] ?? humanizeEventType(raw);
}
